<template>
<div>
 <div class="header_wrap">
	<div class="header container flex_sb_ac">
		<ul class="header_nav flex">
			<li><router-link tag="a" :to="{name:'Home'}">首页</router-link></li>
			<li><a href="http://www.handesoft.com" target="_blank">MES</a></li>
			<li><router-link tag="a" :to="{name:'SetEnquiry'}">招标广场</router-link></li>
			<li><a href="">案例</a></li>
			<li><router-link tag="a" :to="{name:'ModelsIndex'}">模型</router-link></li>
			<li><router-link tag="a" :to="{name:'News'}">资讯</router-link></li>
			<li><router-link tag="a" :to="{name:'Dynamic'}">动态</router-link></li>
			<li><router-link tag="a" :to="{name:'Exhibition'}">展会</router-link></li>
			<li><a style="cursor: pointer" @click="clickBanner">杂志</a></li>
			<li><a href="https://www.imouldyun.com/DataCenter.html" target="_blank">产能平台</a></li>
		</ul>
		<ul class="header_right flex">
			<li><a href="http://cnc-time.com" target="_blank">模具ERP</a></li>
			<li class="nav_btn"><a href="">快速报价</a></li>
			<li class="dropdown">
				<a href="">云工厂</a>
				<div class="dropdown_menu">
					<a href="">帮助中心</a>
					<a href="">后台管理</a>
				</div>
			</li>
			<li><a href="tel:15988939422"><img src="../../assets/images/phone@2x.png" />咨询热线：15988939422</a></li>
			<li class="login">
				<router-link tag="a" :to="{name:'Login'}" v-if="!hasToken">注册 | 登录</router-link>
				<UserMenu v-else :size="25"></UserMenu>
			</li>
			
		</ul>
	</div>
</div>
<div class="header_contain">
        <div class="container flex_sb_ac">
          <div class="logo"><a href="/" style="font-size:24px">模来模往模具制造产能调度平台</a></div>
		  <div class="test-mark"></div>
          <div class="quote"><router-link tag="a" :to="{name:'Enquiry'}">外协招标</router-link></div>
        </div>
      </div>
	  <el-dialog 
  title="imouldSourcing2021"
  :visible.sync="imouldSourcing"
  width="1200px"
  top="40px"
  left="auto"
  center>
  <!-- <div class="demo-image__lazy">
  <el-image v-for="url in urls" :key="url" :src="url" :lazy=true>
    <div slot="error" class="image-slot">
        <el-image :src="url"></el-image>
      </div>
  </el-image>
</div> -->
<iframe src="/2mould.com/index.html" frameborder="0" width="100%" height="800px" style="margin:-25px auto"></iframe>
    </el-dialog>
</div>
</template>

<script>
import UserMenu from '@/components/tools/UserMenu'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'Header',
  props: {
    msg: String
  },
  components:{
	UserMenu
  },
  data(){
	  return {
		  hasToken:false,
		  logo:require('@/assets/images/logo.png'),
		  
      imouldSourcing:false,
	  }
  },
  methods:{
	  clickBanner(index){
        
          this.imouldSourcing = true
        
      }
  },
  created(){
	 if(Vue.ls.get(ACCESS_TOKEN)){
		 this.hasToken = true
	 }else{
		 this.hasToken = false
	 }
	 
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header_wrap{background: #333; color: #b0b0b0; height: 40px;}
.header li{height: 40px; line-height: 40px;}
.header li>a{display: block; color: #b0b0b0; padding: 0 13px; font-size: 12px;}
.header_nav li:hover>a{background: #fff; color: #333;}
.header_right .dropdown{position: relative;}
.header_right .dropdown .dropdown_menu{position: absolute;left:0; white-space: nowrap; background: #fff; box-shadow: 0 2px 4px 2px rgba(0,0,0,.2); line-height: 28px; padding: 8px 0px; display: none; z-index: 200;}
.header_right .dropdown .dropdown_menu a{display: block; color: #222; padding: 0 15px; font-size: 12px;}
.header_right .dropdown .dropdown_menu a:hover{background: #f2f2f2;}
.header_right .dropdown>a{background: url(../../assets/images/zk_down.png) no-repeat calc(100% - 13px) center; padding-right: 23px;}
.header_right .dropdown:hover>a{background: url(../../assets/images/zk_up.png) no-repeat calc(100% - 13px) center;}
.header_right .dropdown:hover .dropdown_menu{display: block;}
.header_right .nav_btn a{margin: 8px 10px; line-height: 24px; background: #0051a4; color: #fff; border-radius: 2px;}
.header_right .nav_btn a:hover{opacity: .8;}
.header_right .login:hover a{color: #fff;}
.header_contain{padding: 12px 0; justify-content: flex-end;background: white;box-shadow: 0 2px 12px 0 rgba(123, 123, 123, 0.1)}
.header_contain .logo{}
.header_contain .logo img{height: 45px; padding: 6px 0;}
.header_contain .test-mark p{font-size: 15px;color:#2c3e50;}
.header_contain .nav{margin-right:50px;}
.header_contain .nav li{ padding: 0 20px;}
.header_contain .nav li a{position: relative; display: inline-block; font-size: 16px; color: #333; }
.header_contain .nav li a:after{content: ""; position: absolute; left: 0; bottom: -12px; background: #0051A4; width: 0; height: 3px; transition: .6s;}
.header_contain .nav li:hover a{color: #0051A4;}
.header_contain .nav li:hover a:after{width: 100%;}
.quote a{display: inline-block; padding: 10px 20px; background: #0051A4; color: #fff; font-size: 14px; border-radius: 2px; transition: .4s;}
.quote a:hover{opacity: .8;}
.el-dialog__body{
  padding:0 25px !important
}
</style>
